<template>
  <div>
    <div class="summary">
      <h3>Ihre Daten</h3>
      <div class="edit">
        <button class="button" @click="changeStep(1)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Geschlecht</div>
        <div class="courseDetailDescription">
          {{ getSalutation(booking.customer.gender) }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Name</div>
        <div class="courseDetailDescription">
          {{ booking.customer.firstname }} {{ booking.customer.lastname }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Adresse</div>
        <div class="courseDetailDescription">
          {{ booking.customer.street }} {{ booking.customer.streetNumber
          }}<br />{{ booking.customer.postal }} {{ booking.customer.city }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">E-Mail</div>
        <div class="courseDetailDescription">{{ booking.customer.email }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Telefon</div>
        <div class="courseDetailDescription">{{ booking.customer.phone }}</div>
      </div>
    </div>
    <div class="summary">
      <h3>Daten des Teilnehmers</h3>
      <div class="edit">
        <button class="button" @click="changeStep(2)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Geschlecht</div>
        <div class="courseDetailDescription">
          {{ getSalutation(booking.participant.gender) }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Name</div>
        <div class="courseDetailDescription">
          {{ booking.participant.firstname }} {{ booking.participant.lastname }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Geburtstag</div>
        <div class="courseDetailDescription">
          {{ booking.participant.dateOfBirth | formatDate }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Weitere Informationen</div>
        <div class="courseDetailDescription">
          {{ booking.participant.moreInformation }}
        </div>
      </div>
    </div>
    <div class="summary">
      <h3>Zahlweise</h3>
      <div class="edit">
        <button class="button" @click="changeStep(3)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Zahlweise</div>
        <div class="courseDetailDescription">
          {{ getPaymentMethod(booking.payment.paymentMethod) }}
        </div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Gutschein</div>
        <div class="courseDetailDescription">{{ coupon }}</div>
      </div>
    </div>
    <div class="summary">
      <h3>Kurs</h3>
      <div class="edit">
        <button class="button" @click="changeStep(4)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">ID</div>
        <div class="courseDetailDescription">{{ course.id }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Titel</div>
        <div class="courseDetailDescription">{{ course.title }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Preis</div>
        <div class="courseDetailDescription">
          <template v-if="event === 0">
            <CoursePrice
              :price="course.price"
              :priceReduced="course.priceReduced"
              :type="course.type"
            />
          </template>
          <template v-else> {{ price | formatCurrency }}</template>
        </div>
      </div>
      <div class="courseDetail" v-if="event > 0">
        <div class="courseDetailTitle">Einzeltermin</div>
        <div class="courseDetailDescription">
          {{ eventDateTime.dow | formatDateWeekday }} {{ eventDateTime.date }}
          {{ eventDateTime.time }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoursePrice from "@/components/CoursePrice.vue";

export default {
  name: "BookingSummary",
  components: { CoursePrice },
  props: ["booking", "course", "event"],
  data() {
    return {
      paymentMethod: ""
    };
  },
  computed: {
    coupon() {
      if (this.booking.payment.coupon !== undefined)
        return this.booking.payment.coupon.toUpperCase();
      return "";
    },
    price() {
      if (this.event === 0) return this.course.price;
      return this.course.priceUnit;
    },
    eventDateTime() {
      if (this.event !== 0) {
        return this.course.events.find(event => event.id === this.event);
      }
      return {};
    }
  },
  methods: {
    changeStep(value) {
      this.$emit("changeStep", value);
    },
    getPaymentMethod(method) {
      if (method === "remittance") return "Überweisung";
      if (method === "paypal") return "PayPal";
      if (method === "creditcard") return "Kreditkarte";
      if (method === "directdebit") return "Lastschrifteinzug";
      return "";
    },
    getSalutation(value) {
      if (value === "female") return "Weiblich";
      if (value === "male") return "Männlich";
      return "Divers";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.summary {
  position: relative;
  margin-bottom: 4rem;

  .edit {
    position: absolute;
    top: 0;
    right: 0;

    button {
      background-color: transparent;
      border-radius: 0;
      padding: 0;
      margin: 0;
      color: var(--orange);
      letter-spacing: 0;
      text-transform: none;
    }
  }
}
</style>
